import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PWAThunk } from 'lib/core/data'
import { MagentoCustomerPaymentTokens } from 'lib/types'
import { Slice } from './types'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'customer/paymentTokens',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<MagentoCustomerPaymentTokens>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchPaymentTokens (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().customer.paymentTokens()
      const paymentTokens = response.data?.customerPaymentTokens

      if (paymentTokens) {
        dispatch(success(paymentTokens))
      } else {
        dispatch(failure())
      }

      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
